import { TextInput } from '@code/innovance-react-ui-kit';
import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { useTranslation } from 'react-i18next';
import { FormElement } from 'src/front/components/FormStyles';
import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';

interface Props {
  formatter: (v: string) => string;
  formMethods: UseFormMethods<IdentityFormData>;
  max: number;
  min: number;
  onChangeHandler: (field: string, mask?: string) => (value: string) => void;
}

const UnitCode: FC<Props> = ({ formatter, formMethods, max, min, onChangeHandler }) => {
  const { control, errors } = formMethods;
  const { t } = useTranslation();

  return (
    <FormElement>
      <Controller
        control={control}
        name="unitCode"
        render={({ onChange, value }) => (
          <TextInput
            errorMessage={t(errors?.unitCode?.message as string, {
              min,
            })}
            formatter={formatter}
            label={t('cardEntry_documentEntry_unitCode_label')}
            maxLength={max}
            name="unitCode"
            onChange={(val) => {
              onChange(val);
              onChangeHandler('unitCode', 'XXX-XXX')(val);
            }}
            value={value}
            required
          />
        )}
      />
    </FormElement>
  );
};

export default UnitCode;
